import type {
	Components,
} from '@mui/material'
import {
	linearProgressClasses,
} from '@mui/material'

export const materialUILinearTheme: {
	components: Components
} = {
	components: {
		MuiLinearProgress: {
			styleOverrides: {
				root: {
				},
			},
			variants: [
				{
					props: {
						color: 'success',
					},
					style: {
						backgroundColor: 'var(--positive-color-opacity-40)',

						[`.${linearProgressClasses.bar1}`]: {
							backgroundColor: 'var(--positive-color)',
						},
					},
				},
				{
					props: {
						color: 'error',
					},
					style: {
						backgroundColor: 'var(--error-color-opacity-40)',

						[`.${linearProgressClasses.bar1}`]: {
							backgroundColor: 'var(--error-color)',
						},
					},
				},
				{
					props: {
						color: 'warning',
					},
					style: {
						backgroundColor: 'var(--warning-color-opacity-40)',

						[`.${linearProgressClasses.bar1}`]: {
							backgroundColor: 'var(--warning-color)',
						},
					},
				},
				{
					props: {
						color: 'secondary',
					},
					style: {
						backgroundColor: 'var(--secondary-color-opacity-40)',

						[`.${linearProgressClasses.bar1}`]: {
							backgroundColor: 'var(--secondary-color)',
						},
					},
				},
				{
					props: {
						color: 'primary',
					},
					style: {
						backgroundColor: 'var(--primary-color-opacity-40)',

						[`.${linearProgressClasses.bar1}`]: {
							backgroundColor: 'var(--primary-color)',
						},
					},
				},
			],
		},
	},
}
